const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
let exponeaCookieUrl = params.exponeaCookie;
if (params.language) {
  localStorage.setItem('languageCode', params.language)
}
console.log("params", params.exponeaCookie);

!function (e, n, t, i, o, r) { var a = 4e3, c = "xnpe_async_hide"; function s(e) { return e.reduce((function (e, n) { return e[n] = function () { e._.push([n.toString(), arguments]) }, e }), { _: [] }) } function m(e, n, t) { var i = t.createElement(n); i.src = e; var o = t.getElementsByTagName(n)[0]; return o.parentNode.insertBefore(i, o), i } r.target = r.target || "https://api.exponea.com", r.file_path = r.file_path || r.target + "/js/exponea.min.js", e[t] = s(["anonymize", "initialize", "identify", "update", "track", "trackLink", "trackEnhancedEcommerce", "getHtml", "showHtml", "showBanner", "showWebLayer", "ping", "getAbTest", "loadDependency", "getRecommendation", "reloadWebLayers"]), e[t].notifications = s(["isAvailable", "isSubscribed", "subscribe", "unsubscribe"]), e[t].snippetVersion = "v2.1.0", function (e, n, t) { e[n]["_" + t] = {}, e[n]["_" + t].nowFn = e[t] && e[t].now ? e[t].now.bind(e[t]) : Date.now, e[n]["_" + t].snippetStartTime = e[n]["_" + t].nowFn() }(e, t, "performance"), function (e, n, t, i, o, r) { e[o] = { sdk: e[i], sdkObjectName: i, skipExperiments: !!t.new_experiments, sign: t.token + "/" + (r.exec(n.cookie) || ["", "new"])[1], path: t.target } }(e, n, r, t, o, RegExp("__exponea_etc__" + "=([\w-]+)")), function (e, n, t) { m(e.file_path, n, t) }(r, i, n), function (e, n, t, i, o, r, s) { if (e.new_experiments) { !0 === e.new_experiments && (e.new_experiments = {}); var p = e.new_experiments.hide_class || c, u = e.new_experiments.timeout || a, _ = encodeURIComponent(r.location.href.split("#")[0]), l = e.target + "/webxp/" + n + "/" + r[t].sign + "/modifications.min.js?http-referer=" + _ + "&timeout=" + u + "ms"; "sync" === e.new_experiments.mode && r.localStorage.getItem("__exponea__sync_modifications__") ? function (e, n, t, i, o) { t[o][n] = "<" + n + ' src="' + e + '"></' + n + ">", i.writeln(t[o][n]), i.writeln("<" + n + ">!" + o + ".init && document.writeln(" + o + "." + n + '.replace("/' + n + '/", "/' + n + '-async/").replace("><", " async><"))</' + n + ">") }(l, n, r, s, t) : function (e, n, t, i, o, r, a, c) { r.documentElement.classList.add(e); var s = m(t, i, r); function p() { o[c].init || m(t.replace("/" + i + "/", "/" + i + "-async/"), i, r) } function u() { r.documentElement.classList.remove(e) } s.onload = p, s.onerror = p, o.setTimeout(u, n), o[a]._revealPage = u }(p, u, l, n, r, s, o, t) } }(r, i, o, 0, t, e, n), function (e, n, t) { e[n].start = function (i) { i && Object.keys(i).forEach((function (e) { return t[e] = i[e] })), e[n].initialize(t) } }(e, t, r) }(window, document, "exponea", "script", "webxpClient", {
    target: "https://analytics-api.airportr.com",
    token: "0f3cbae2-ee18-11eb-9684-4e82b182892c",
    new_experiments: { mode: "async" },
    // replace with current customer ID or leave commented out for an anonymous customer
    // customer: window.currentUserId,
    track: {
        visits: true,
    },
});

function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if (d > 0) {//Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {

    let cookieCheck = getCookie("airportr_exponea_cookie");
    if (exponeaCookieUrl == undefined || exponeaCookieUrl == null || exponeaCookieUrl == "") {
        if(cookieCheck == '' || cookieCheck == undefined || cookieCheck == null) {
            const cookievalue = generateUUID() + '-ab' + Math.floor(100 + Math.random() * 900);
            setCookie("airportr_exponea_cookie", cookievalue, 700);
        }
    }
    if (exponeaCookieUrl) {
        setCookie("airportr_exponea_cookie", exponeaCookieUrl, 700);
    }

    // if (cookieCheck != "") {
    //     if (exponeaCookieUrl == undefined || exponeaCookieUrl == null || exponeaCookieUrl == "") {
    //         setCookie("airportr_exponea_cookie", cookieCheck, 700);
    //     } else {
    //         if (exponeaCookieUrl != cookieCheck) {
    //             setCookie("airportr_exponea_cookie", exponeaCookieUrl, 700);
    //         }
    //     }
    // } else {
    //     const cookievalue = generateUUID() + '-ab' + Math.floor(100 + Math.random() * 900);
    //     setCookie("airportr_exponea_cookie", cookievalue, 700);
    // }
}

window.addEventListener('load', function () {
    checkCookie();
    // get cookie funtion for exponea
    var guid_exponea = getCookie('airportr_exponea_cookie');
    exponea.start({
        customer: { airportr_exponea_cookie: guid_exponea } // from the last step
    });
})
